import { render, staticRenderFns } from "./ExerciseList.vue?vue&type=template&id=d4cbf806&scoped=true&"
import script from "./ExerciseList.vue?vue&type=script&lang=ts&"
export * from "./ExerciseList.vue?vue&type=script&lang=ts&"
import style0 from "./ExerciseList.vue?vue&type=style&index=0&id=d4cbf806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cbf806",
  null
  
)

export default component.exports